import type { PartialBy } from '@ipfabric/utils/types/PartialBy';
import { makeTypeGuardByPropertyValue } from '@ipfabric/utils/types/makeTypeGuardByPropertyValue';
import type { ButtonBaseProps } from '../Button/Button.types';
import type { IconProps } from '../Icon/Icon';
import type { IconGlyph } from '../Icon/IconGlyph';
import {
  type InteractiveAtomRenderedAsAnchorProps,
  type InteractiveAtomRenderedAsButtonProps,
  type InteractiveAtomRenderedAsLinkProps,
  fromInteractiveAtomToIconSize,
} from '../utils/InteractiveAtomProps';

export const fromIconButtonToIconSize = fromInteractiveAtomToIconSize;

export type IconButtonBaseProps = Omit<
  ButtonBaseProps,
  'iconStyle' | 'iconPosition'
> & {
  icon: IconGlyph;
  iconProps?: Omit<IconProps, 'glyph'>;
};

// make 'renderAs' optional with 'button' fallback value defined in the component
export type IconButtonRenderedAsButtonProps = PartialBy<
  InteractiveAtomRenderedAsButtonProps<IconButtonBaseProps>,
  'renderAs'
>;
export type IconButtonRenderedAsAnchorProps =
  InteractiveAtomRenderedAsAnchorProps<IconButtonBaseProps>;
export type IconButtonRenderedAsLinkProps =
  InteractiveAtomRenderedAsLinkProps<IconButtonBaseProps>;

export type IconButtonProps =
  | IconButtonRenderedAsButtonProps
  | IconButtonRenderedAsAnchorProps
  | IconButtonRenderedAsLinkProps;

export const isIconButtonRenderedAsButton = makeTypeGuardByPropertyValue<
  IconButtonProps,
  IconButtonRenderedAsButtonProps
>()('renderAs', 'button');

export const isIconButtonRenderedAsAnchor = makeTypeGuardByPropertyValue<
  IconButtonProps,
  IconButtonRenderedAsAnchorProps
>()('renderAs', 'anchor');

export const isIconButtonRenderedAsLink = makeTypeGuardByPropertyValue<
  IconButtonProps,
  IconButtonRenderedAsLinkProps
>()('renderAs', 'link');
